import { type UserDetailsWithPermissionDto } from '@/api/generated';

/**
 * An account is approved once it is enabled and has a role. A user without a role keeps seeing the
 * waiting-for-approval screen even when holding additional permissions.
 */
export const isApprovedUser = (
  user: Pick<UserDetailsWithPermissionDto, 'enabled' | 'role'>,
): boolean => user.enabled && Boolean(user.role);
